import dayjs from 'dayjs';

export const dateToSeconds = (dateSlug: string) => {
  const formattedDate = new Date(dateSlug);
  const systemDate = new Date();

  return ((formattedDate.getTime() / 1000) - (systemDate.getTime() / 1000));
};

export const fetchExpiryDate = ({ creationDate, daysToExpire }: { creationDate: string; daysToExpire: number }) => {
  const expiryDate = new Date(creationDate);
  expiryDate.setDate(expiryDate.getDate() + daysToExpire);
  return (expiryDate.toISOString());
};

export const dateToMonths = (dateString: string) => {
  const currentDate = new Date();

  const timeDifference = dayjs(currentDate).diff(dateString, 'month');
  return timeDifference;
};
